import React from "react";

/**
 * Render a square team logo using the team color + 2-3 letter shortcode.
 * Drop in real logo URLs later (data/input.json -> team.logo) and we'll prefer those.
 */
const TeamLogo = ({ team, size = 28 }) => {
  if (!team) return null;
  const style = {
    width: size,
    height: size,
    background: team.color || "#222",
    color: team.text || "#fff",
    fontSize: size * 0.42,
  };
  if (team.logo) {
    return (
      <div
        className="rounded-sm flex items-center justify-center shrink-0 border border-black/40 overflow-hidden"
        style={{ width: size, height: size, background: team.color || "#0A0D0A" }}
        data-testid={`team-logo-${team.short}`}
        aria-label={team.name}
      >
        <img
          src={team.logo}
          alt={team.name || team.short}
          loading="lazy"
          className="w-full h-full object-contain"
          style={{ padding: Math.max(1, Math.round(size * 0.06)) }}
        />
      </div>
    );
  }
  return (
    <div
      className="rounded-sm flex items-center justify-center font-display font-bold tracking-tight shrink-0 border border-black/30"
      style={style}
      data-testid={`team-logo-${team.short}`}
      aria-label={team.name}
    >
      {team.short}
    </div>
  );
};

export default TeamLogo;
